import React from 'react'

function Offer() {
  return (
    <div id = "presentaion">
        <div className='name'>
            <h2>SHOW US</h2>
            <h1><span>WHAT</span> YOU GOT !!!</h1>
            {/* <p className='details'> some paragraph stuffs</p> */}
            <div className='header-btns'>
                {/* <a href='#' className='header-btn'>REGISTER</a> */}
            </div>
        </div>

    </div>
  )
}

export default Offer;